// Module
var code = "\n    <div class=\"row-preview\">\n        <div class=\"item-name\"><hr class=\"separator-record-field\" /></div>\n    </div>\n";
// Exports
var htmlContent = code;
jQuery.templatesHtml['#separator-record-field'] = htmlContent;
module.exports = "separator-record-field";